query GetSunProtections($limit: Int = 50, $page: Int = 1) {
    SunProtections(limit: $limit, page: $page, sort: "_order") {
        docs {
            id
            name
            subtitle
            hasFrameColor
            image {
                url
            }
            fabricColors {
                id
                name
                hexColor
                price
                type
                image {
                    url
                }
            }
            frameColors {
                id
                name
                hexColor
                price
            }
            colorCombinations {
                id
                frameColorName
                fabricColorName
                irrelevant
                image {
                    url
                    alt
                }
            }
        }
    }
}
